import React, { createRef } from "react";
import fetchQR from "~/backend/fetchQR";
import css from "./css";
import { connect } from "~/redux/connect";

import { Box, Card, CardText, CardTitle, Center, Fade, Image, WithColorMode, ZStack, } from "~/native-ui";

const HelpText = WithColorMode(({ colorMode, size, ...props }) => {
    return <Center bg={ colorMode } width={size} height={size} p={8} textAlign="center" className={ css.help_text} { ...props } />
})

const mobileLoginFactory = (Card, CardText, CardTitle) => {
    return class MobileLogin extends React.PureComponent {
        imageRef = createRef();
        unmounted = false;
        state = {
            src: undefined,
            imgLoaded: false,
        }

        componentDidMount() {
            this.fetchQR()   
        }

        setStateOrReturn(...args) {
            if (this.unmounted) {
                return;
            }

            this.setState(...args);
        }

        onImageLoaded = () => {
            this.setStateOrReturn({
                imgLoaded: true
            })
        }

        async fetchQR () {
            const imageResponse = await fetchQR();
            const img = this.imageRef.current;

            
            this.setStateOrReturn({
                src: imageResponse.data.body
            })

            // img.src = imageResponse.data.body;
            // img.onload = e => img.classList.remove(css.img_loading);

            img?.setNativeProps({
                opacity: 1,
            })
        }

        componentWillUnmount() {
            this.unmounted = true;
        }

        renderHelpText() {
            const { trans } = this.props;
            return (
                <Fade in={ !this.state.imgLoaded }>
                    <HelpText size={ 250 }>
                        { trans('mobile_login.image_loading_help_text') }
                    </HelpText>
                </Fade>
            )
        }

        renderQR() {
            return <Box size={ 250 }>
                {
                    <Image
                        source={{ uri: this.state.src || "", cache: "reload" }}
                        onLoad={this.onImageLoaded}
                        style={{
                            opacity: Number(!!this.state.src),
                            height: 250,
                            width: 250,
                        }}
                        ref={ this.imageRef }
                    />
                }
            </Box>
        }
        

        renderDescription() {
            const { trans } = this.props;
            const description = trans('mobile_login.description');
            if (!description) return null;

            return <CardText>{ description }</CardText>
        }

        render() {
            const { trans } = this.props;
            const title = trans('mobile_login.title');

            return (
                <Card shadow={ 10 }>
                    <CardTitle title={ title }></CardTitle>
                    { this.renderDescription() }
                    <CardText borderWidth={0} className={ css.cardBody }>
                        <Box w={250} h={250} mx="auto">
                            <ZStack className={ css.qr_container }>
                                {this.renderQR()}
                                {this.renderHelpText()}
                            </ZStack>
                        </Box>
                    </CardText>
                </Card>
            )
        }
    }
}

export const MobileLogin = connect()(mobileLoginFactory(Card, CardText, CardTitle))
